/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { InboxEntity } from './types';

interface State {
  readonly data?: InboxEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: (inboxIDs: string[]) => Promise<void>;
}

export default function useDataAPIGetInboxesByIDs(inboxIDs?: string[]): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(inboxIDs: string[]): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getInboxesByIDs(inboxIDs);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    if (!inboxIDs) return;

    fetch(inboxIDs);
  }, [inboxIDs]);

  return { ...state, refetch: fetch };
}
